module.exports = __webpack_public_path__ + "img/landing_mobile.cd1ef402.png";